import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const DiscountList = lazy(() =>
  import("../../container/discount/DiscountList")
);
const AddDiscount = lazy(() => import("../../container/discount/AddDiscount"));
const EditDiscount = lazy(() =>
  import("../../container/discount/EditDiscount")
);
const DiscountStats = lazy(() =>
  import("../../container/discount/DiscountStats")
);
const CouponTester = lazy(() =>
  import("../../container/discount/CouponTester")
);
const NotFound = lazy(() => import("../../container/pages/404"));

function DiscountRoute() {
  return (
    <Routes>
      <Route path="/" element={<DiscountList />} />
      <Route path="new" element={<AddDiscount />} />
      <Route path="edit/:id" element={<EditDiscount />} />
      <Route path="stats/:id" element={<DiscountStats />} />
      <Route path="test" element={<CouponTester />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default DiscountRoute;
